var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_911_47458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7342 32.7635C34.7342 34.3598 33.436 35.658 31.8397 35.658H2.89452C1.29819 35.658 0 34.3598 0 32.7635C0 29.5708 2.59638 26.9745 5.78903 26.9745H28.9452C32.1378 26.9745 34.7342 29.5708 34.7342 32.7635ZM10.1308 18.2909C10.1308 19.8872 8.83261 21.1854 7.23629 21.1854V22.6327C7.23629 23.433 6.58792 24.0799 5.78903 24.0799C4.99014 24.0799 4.34177 23.433 4.34177 22.6327V21.1854C2.74545 21.1854 1.44726 19.8872 1.44726 18.2909V11.0546C1.44726 8.09499 3.23751 5.55216 5.78903 4.43198V2.37109C5.78903 1.57075 6.4374 0.923828 7.23629 0.923828C8.03517 0.923828 8.68355 1.57075 8.68355 2.37109V3.81834H24.6034V2.37109C24.6034 1.57075 25.2517 0.923828 26.0506 0.923828C26.8495 0.923828 27.4979 1.57075 27.4979 2.37109V3.96452C30.7962 4.63749 33.2869 7.5595 33.2869 11.0546V25.2551C32.0075 24.5127 30.527 24.0799 28.9452 24.0799H20.2616V16.8437C20.2616 16.0448 19.6118 15.3964 18.8143 15.3964H11.5781C10.7806 15.3964 10.1308 16.0448 10.1308 16.8437V18.2909ZM24.6034 13.2255C24.6034 14.4238 25.5759 15.3964 26.7743 15.3964C27.9726 15.3964 28.9452 14.4238 28.9452 13.2255C28.9452 12.0272 27.9726 11.0546 26.7743 11.0546C25.5759 11.0546 24.6034 12.0272 24.6034 13.2255ZM24.6034 19.0145C24.6034 20.2129 25.5759 21.1854 26.7743 21.1854C27.9726 21.1854 28.9452 20.2129 28.9452 19.0145C28.9452 17.8162 27.9726 16.8437 26.7743 16.8437C25.5759 16.8437 24.6034 17.8162 24.6034 19.0145Z",
    fill: "#45445E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_911_47458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.7342,
    height: 34.7342,
    fill: "white",
    transform: "translate(0 0.923828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStitchIcon);
export default __webpack_public_path__ + "static/media/stitch-icon.22b91f64dbc47ae53c558aef7a46c3a1.svg";
export { ForwardRef as ReactComponent };